import { render, staticRenderFns } from "./camera-regions.vue?vue&type=template&id=62e01268&"
import script from "./camera-regions.vue?vue&type=script&lang=ts&"
export * from "./camera-regions.vue?vue&type=script&lang=ts&"
import style0 from "./camera-regions.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../../../../tmp/ffsecurity-ui/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports